import DoctorAccordionDetails from './doctor-accordion.details';

export default DoctorAccordionDetails;
